import ChangePayoutStatus from "./ChangePayoutStatus.mock"
import GetPayouts from "./GetPayouts.mock"
import GetPayout from "./GetPayout.mock"

export default [ChangePayoutStatus, GetPayouts, GetPayout]
